import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { sfAuthFeature } from './store/sf-auth.store';
import * as SfDictionaryEffects from './store/sf-dictionary.effects';
import * as SfAuthEffects from './store/sf-auth.effects';
import * as coreStore from '../../../core/store/core.reducer';
import { MatDialogModule } from '@angular/material/dialog';
import { SdCacheModule } from '../../../shared/sd-cache/sd-cache.module';
import {
  featureName as sideDrawerFeatureName,
  sidedrawerReducer,
} from '../../../sidedrawer/store/sidedrawer.reducer';
import {
  featureName as networksFeatureName,
  networksReducer,
} from '../../../networks/store/networks.reducer';
import { queueFeature } from '../../../queue/store/queue.reducer';
import {
  featureName as signaturesFeatureName,
  signatureReducer,
} from '../../../signature/store/signature.reducer';
import * as QueueEffects from '../../../queue/store/queue.effects';
import { NetworksEffects } from '../../../networks/store/networks.effects';
import { NetworksCrudEffects } from '../../../networks/store/networks-crud/networks-crud.effect';
import { SidedrawerEffects } from '../../../sidedrawer/store/sidedrawer.effects';
import { SignatureEffects } from '../../../signature/store/signature.effects';
import { RemindersModule } from '../../../reminders/reminders.module';
import { SfCoreEffects } from './store/sf-core.effects';
import { networkSearchFeature } from '../../../networks/store/network-search.store';
import * as NetworkSearchEffects from '../../../networks/store/network-search.effects';
import {
  featureName as recordsFeatureName,
  recordsReducer,
} from '../../../records/store/records.reducer';
import { RemindersListEffects } from 'src/app/reminders/store/reminders-list.effects';

@NgModule({
  imports: [
    StoreModule.forFeature(sfAuthFeature),
    StoreModule.forFeature(coreStore.featureName, coreStore.coreReducer),
    StoreModule.forFeature(sideDrawerFeatureName, sidedrawerReducer),
    StoreModule.forFeature(networksFeatureName, networksReducer),
    StoreModule.forFeature(networkSearchFeature),
    StoreModule.forFeature(queueFeature),
    StoreModule.forFeature(signaturesFeatureName, signatureReducer),
    StoreModule.forFeature(recordsFeatureName, recordsReducer),
    EffectsModule.forFeature([
      SfDictionaryEffects,
      SfAuthEffects,
      SfCoreEffects,
      QueueEffects,
      NetworksEffects,
      NetworksCrudEffects,
      SidedrawerEffects,
      SignatureEffects,
      NetworkSearchEffects,
      RemindersListEffects,
    ]),
    SdCacheModule,
    MatDialogModule,
    RemindersModule,
  ],
})
export class SfCoreModule {}
